






import {Component, Prop, Vue} from "vue-property-decorator";

@Component({name: "ProgrammingLanguages"})
export default class ProgrammingLanguages extends Vue {
    @Prop()
    public languages!: string[];

    private badgeColor(language: string): string {
        switch (language) {
            case 'Typescript':
            case 'TypeScript':
                return 'badge-primary';
            case 'WebGL':
                return 'badge-secondary';
            case 'HTML':
                return 'badge-success';
            case 'CSS':
                return 'badge-warning';
            case 'C++':
            case 'c++': return 'badge-success';
            case 'Vue': return 'badge-warning';

            default: return 'badge-dark';
        }
    }
}
